/**
 * Defers Shopify video source downloads until near the viewport.
 * Requires data-deferred-video + source[data-src] from deferred-video-tag.
 */
(function () {
  if (window.themeDeferredVideo) return;

  var ROOT_MARGIN = '250px 0px';

  function activateSources(video) {
    if (!video || video.dataset.deferredLoaded === 'true') return;

    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) {
      video.dataset.deferredLoaded = 'true';
      return;
    }

    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
      sources[i].removeAttribute('data-src');
    }

    video.preload = 'metadata';
    video.dataset.deferredLoaded = 'true';
    video.load();
  }

  function activateVideo(video) {
    activateSources(video);
    if (video.dataset.autoplay !== 'true') return;

    video.muted = true;
    var playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  function observeVideo(video) {
    if (video.dataset.deferredObserving === 'true') return;
    video.dataset.deferredObserving = 'true';

    if (!('IntersectionObserver' in window)) {
      activateVideo(video);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          activateVideo(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      },
      { rootMargin: ROOT_MARGIN, threshold: 0.01 },
    );

    observer.observe(video);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('video[data-deferred-video]').forEach(observeVideo);
  }

  window.themeDeferredVideo = {
    ensure: activateSources,
    init: init,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
